import React from 'react';
import PropTypes from 'prop-types';

import {
    TransitionCollapseHeight,
    type TransitionCollapseHeightProps,
} from 'components/Transition';

export type FormAlertTransitionProps = TransitionCollapseHeightProps;

export const FormAlertTransition: React.FC<FormAlertTransitionProps> = ({
    show = false,
    className,
    children,
    ...rest
}) => {
    const ref = React.useRef<HTMLDivElement>(null);

    return (
        <TransitionCollapseHeight {...rest} appear quick show={show} nodeRef={ref}>
            <div ref={ref} className={className}>
                {children}
            </div>
        </TransitionCollapseHeight>
    );
};

FormAlertTransition.displayName = 'FormAlertTransition';
FormAlertTransition.propTypes = {
    show: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};
